import { combineReducers, getDefaultMiddleware, configureStore } from '@reduxjs/toolkit'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { createMemoryHistory } from 'history'
import { reducer as formReducer } from 'redux-form'
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga'

import analyticsReducer from './reducers/analytics/analytics'
import appReducer from './reducers/app/app'
import clientReducer from './reducers/client/client'
import codetableReducer from './reducers/codetable/codetable'
import contractReducer from './reducers/contract/contract'
import modalDialogReducer from './reducers/modalDialog/modalDialog'
import modalLoaderReducer from './reducers/modalLoader/modalLoader'
import notificationReducer from './reducers/notification/notification'
import paymentReducer from './reducers/payment/payment'
import scoringReducer from './reducers/scoring/scoring'
import popReducer from './reducers/pop/pop'
import productReducer from './reducers/product/product'
import requirementReducer from './reducers/requirement/requirement'
import signingReducer from './reducers/signing/signing'
import wizardReducer from './reducers/wizard/wizard'

export const history = createMemoryHistory({ keyLength: 0 })

// todo fix
export const reducer = combineReducers({
  analytics: analyticsReducer as any,
  app: appReducer,
  client: clientReducer,
  codetable: codetableReducer,
  contract: contractReducer as any,
  form: formReducer,
  modalDialog: modalDialogReducer,
  modalLoader: modalLoaderReducer,
  notification: notificationReducer,
  payment: paymentReducer as any,
  pop: popReducer as any,
  product: productReducer,
  requirement: requirementReducer as any,
  router: connectRouter(history),
  scoring: scoringReducer,
  signing: signingReducer as any,
  wizard: wizardReducer,
})

declare global {
  interface Window {
    Visitor?: any
  }
}

// eslint-disable-next-line no-underscore-dangle

// eslint-disable-next-line import/no-mutable-exports
let dispatch: any
// eslint-disable-next-line import/no-mutable-exports
let getState: any
// eslint-disable-next-line import/no-mutable-exports
let runSaga: any

export const sagaMiddleware: SagaMiddleware = createSagaMiddleware()

export default () => {
  const store = configureStore({
    middleware: [
      ...getDefaultMiddleware({
        serializableCheck: false, // Added due to "id" function in each return value of redux action
      }),
      routerMiddleware(history),
      sagaMiddleware,
    ] as const,
    reducer,
  })

  dispatch = store.dispatch
  getState = store.getState

  return store
}

export { dispatch, getState, runSaga }
